import React, { Component } from "react";
import { connect } from "react-redux";
import OptionGroupScroll from "./OptionGroupScroll";
import OptionGroupGrid from "./OptionGroupGrid";
import OptionGroupList from "./OptionGroupList";
import { Divider, Grid } from "@material-ui/core";
import { getDiscountedPrice } from "../../../../Helpers/promotions";
import Collapsible from "react-collapsible";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { getProductInventory } from "../../../../store/reducers/store";
import { getCurrencyIcon } from "../../../../Helpers/currencyConverter";

class ProductOptionGroup extends Component {
  state = {
    open: !this.props.option.collapsed_by_default,
    level: this.props.level || "",
    parentStyle: this.props.parentStyle || "",
  };
  getMinMaxText = () => {
    const { option, language } = this.props;
    let text = "";

    if (option.is_required) {
      text = `${language == "arabic" ? "أدنى" : "min"}: ${option.minimum}${
        option.maximum ? ", " : ""
      }`;
    }
    if (option.maximum) {
      text += `${language == "arabic" ? "أقصى" : "max"}: ${option.maximum}`;
    }

    return text;
  };

  handlePreselectChoices = (choice, optionSelectedAmount, quantity) => {
    const {
      option,
      productUsedComponents,
      usedComponents,
      productQuantity,
      groupID,
    } = this.props;
    let newQuantity = quantity;
    let resetOptions = false;

    if (optionSelectedAmount >= (option.maximum || Infinity)) {
      if (option.maximum === 1) resetOptions = true;
      else return;
    }

    if (choice.related_product && choice.inventory !== null) {
      const totalUsedComponents = { ...usedComponents };
      Object.entries(productUsedComponents).forEach(
        ([productId, optionQuantity]) => {
          const newProductId = productId.toString().replace("Q", "");
          totalUsedComponents[newProductId] =
            (totalUsedComponents[newProductId] || 0) +
            optionQuantity *
              ((productId.toString().includes("Q") && 1) ||
                productQuantity.quantity);
        }
      );
      const choiceInventory = getProductInventory(
        choice.related_product,
        totalUsedComponents
      );

      if (
        choiceInventory <
        newQuantity *
          ((option.quantity_exclusive && 1) || productQuantity.quantity)
      )
        return;
    }
    this.props.controlOptions(
      option,
      choice,
      newQuantity,
      groupID,
      resetOptions
    );
  };
  getConditionalOptions = (choice, option) => {
    return this.props.allOptions?.filter(
      (op) =>
        op.condition_parent === choice && op.condition_parent_option === option
    );
  };
  checkChoiceSelected = (choice, option, groupID = null) => {
    return !groupID
      ? this.props.selectedOptions?.[option]?.selectedOptions?.[choice] ?? false
      : this.props.selectedOptions?.[`${option}-${groupID}`]?.selectedOptions?.[
          choice
        ] ?? false;
  };

  componentDidMount = () => {
    const { option } = this.props;
    let optionSelectedAmount = 0;
    option.choices.forEach((choice) => {
      if (choice.preselected > 0 && !this.props.editMode) {
        const minQuantity = option.multiple
          ? Math.min(
              option.maximum || Infinity,
              choice.maximum || Infinity,
              choice.preselected
            )
          : 1;
        this.handlePreselectChoices(choice, optionSelectedAmount, minQuantity);
        optionSelectedAmount += minQuantity;
      }
    });
  };

  render() {
    const {
      option,
      selectedOptions,
      controlOptions,
      settings,
      themeColor,
      language,
      discountAmount,
      productQuantity,
      productUsedComponents,
      editedProduct,
      groupID,
    } = this.props;
    const { parentStyle } = this.state;
    const optionKey = !groupID ? option.id : option.id + "-" + groupID;

    const optionSelected = selectedOptions[optionKey]?.selected || 0;
    const hasError = Boolean(selectedOptions[optionKey]?.error);
    const optionTotalPrice = selectedOptions[optionKey]?.totalPrice || 0;

    const discoutedtotalPrice = getDiscountedPrice(
      optionTotalPrice,
      discountAmount,
      null,
      { options: selectedOptions[optionKey] || { selectedOptions: {} } },
      true
    );
    const isChild = this.state.level == "bottom";
    let denseChild = isChild && parentStyle == "dense";
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        id={optionKey}
        className={`noselect ${
          language == "arabic" ? "text-right" : "text-left"
        } ${!groupID && !isChild ? "mt-6" : ""} ${isChild ? "mt-0 px-3" : ""}`}
        style={{
          position: "relative",
        }}
      >
        <Collapsible
          handleTriggerClick={(e) => {
            this.setState({ open: !this.state.open });
          }}
          trigger={
            <div
              style={{
                fontWeight: "bold",
                backgroundColor:
                  ((!this.state.open || groupID) && "white") ||
                  (!isChild && "rgb(244, 245, 245)"),
                fontSize: 15,
                direction: language === "arabic" && "rtl",
                display: "flex",
                alignItems: "center",
                transition: "0.4s linear",
                backgroundPosition: "right bottom",
              }}
              className={`px-4 ${isChild && !denseChild ? "p-3" : "pt-3 pb-3"}`}
            >
              <div>{language == "arabic" ? option.ar_name : option.name}</div>
              {option.collapsible && (
                <ArrowDropDownIcon
                  style={{
                    marginLeft: language == "english" && "auto",
                    marginRight: language == "arabic" && "auto",
                    fontSize: 30,
                  }}
                />
              )}

              {hasError && (
                <span style={{ color: "red", fontSize: 12 }}>
                  {language == "arabic"
                    ? selectedOptions[optionKey].errorTextArabic
                    : selectedOptions[optionKey].errorText}
                </span>
              )}
            </div>
          }
          open={this.state.open}
          triggerDisabled={!option.collapsible}
        >
          <div
            className={groupID ? "px-2" : ""}
            style={{
              backgroundColor: "white",
              minHeight: 180,
            }}
          >
            <Grid
              container
              direction={language === "arabic" && "row-reverse"}
              alignItems={"center"}
              className={`${!isChild && "py-3"}`}
            >
              <Grid
                item
                className={`px-3 ${
                  isChild && parentStyle == "dense"
                    ? language == "right"
                      ? "ml-3"
                      : "mr-3"
                    : "mx-3 "
                }`}
                style={{
                  display: "inline-block",
                  borderRadius: 10,
                  background: hasError ? "red" : "#AAAAAA",
                  color: "white",
                  paddingTop: !option.layout === "dense" && "0.2rem",
                  paddingBottom: !option.layout === "dense" && "0.2rem",
                }}
              >
                {option.is_required
                  ? language == "arabic"
                    ? "مطلوب"
                    : "Required "
                  : language == "arabic"
                  ? "إختياري"
                  : "Optional "}
              </Grid>

              <Grid item>{this.getMinMaxText()}</Grid>
            </Grid>
            {optionSelected > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: denseChild ? 15 : !isChild ? 60 : 8,
                  right: language !== "arabic" ? (denseChild ? 2 : 0) : "",
                  left: language === "arabic" ? (denseChild ? 2 : 0) : "",
                  textAlign: (language === "arabic" && "left") || "right",
                  opacity: this.state.open ? 1 : 0,
                  transition: "opacity 0.5s ease",
                }}
              >
                <span
                  onClick={() =>
                    controlOptions(option, undefined, undefined, groupID)
                  }
                  className="pointer"
                  style={{
                    fontSize: 12,
                    color: themeColor,
                    fontWeight: "bold",
                    position: "relative",
                    right: language !== "arabic" && 15,
                    left: language === "arabic" && 15,
                  }}
                >
                  {language !== "arabic" ? "Clear all" : "مسح الكل"}
                </span>
                <div
                  style={{
                    color: themeColor,
                    position: "relative",
                    backgroundColor: "white",
                    right: language !== "arabic" ? 15 : -15,
                    direction: language === "english" && "rtl",
                    whiteSpace: "nowrap",
                  }}
                  className={currencyIcon}
                >
                  {`${
                    language === "arabic"
                      ? settings.currency_local
                      : settings.currency_english
                  } ${discoutedtotalPrice?.toFixed(
                    settings.currency_decimals
                  )} +`}
                </div>
              </div>
            )}

            {option.layout === "grid" ? (
              <OptionGroupGrid
                option={option}
                controlOptions={controlOptions}
                selectedOptions={selectedOptions}
                themeColor={themeColor}
                level={this.state.level}
                getConditionalOptions={(choice, option) =>
                  this.getConditionalOptions(choice, option)
                }
                checkChoiceSelected={(choice, option, groupID) =>
                  this.checkChoiceSelected(choice, option, groupID)
                }
                discountAmount={discountAmount}
                productQuantity={productQuantity}
                productUsedComponents={productUsedComponents}
                editedProduct={editedProduct}
                groupID={groupID}
                optionKey={optionKey}
              />
            ) : option.layout === "scroll" ? (
              <OptionGroupScroll
                option={option}
                controlOptions={controlOptions}
                selectedOptions={selectedOptions}
                themeColor={themeColor}
                level={this.state.level}
                getConditionalOptions={(choice, option) =>
                  this.getConditionalOptions(choice, option)
                }
                checkChoiceSelected={(choice, option, groupID) =>
                  this.checkChoiceSelected(choice, option, groupID)
                }
                discountAmount={discountAmount}
                productQuantity={productQuantity}
                productUsedComponents={productUsedComponents}
                editedProduct={editedProduct}
                groupID={groupID}
                optionKey={optionKey}
              />
            ) : (
              <OptionGroupList
                option={option}
                controlOptions={controlOptions}
                selectedOptions={selectedOptions}
                themeColor={themeColor}
                level={this.state.level}
                getConditionalOptions={(choice, option) =>
                  this.getConditionalOptions(choice, option)
                }
                checkChoiceSelected={(choice, option, groupID) =>
                  this.checkChoiceSelected(choice, option, groupID)
                }
                parentStyle={option.layout}
                discountAmount={discountAmount}
                productQuantity={productQuantity}
                productUsedComponents={productUsedComponents}
                editedProduct={editedProduct}
                groupID={groupID}
                optionKey={optionKey}
                editMode={this.props.editMode}
              />
            )}
          </div>
        </Collapsible>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    usedComponents: state.store.used_components,
  };
};

export default connect(mapStateToProps)(ProductOptionGroup);
